import * as Yup from "yup";
import { TParcelDetailsGE } from "@/types/parcel.types";

// @ts-ignore
export const parcelDetailsSchemaGe: Yup.ObjectSchema<TParcelDetailsGE> =
  Yup.object().shape({
    country: Yup.number().required("validations_country_required"),
    deliveryFromFcountryTypeId: Yup.string()
      .required("validations_transportation_type")
      .required("validations_transportation_type_required"),
    dontRemember: Yup.boolean(),
    trackingNumber: Yup.string().when("dontRemember", {
      is: false,
      then: (schema) => schema.required("validations_tracking_number_required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    defaultAddressDeliveryTypeId: Yup.number(),
    departIdPreDelivery: Yup.object().when("defaultAddressDeliveryTypeId", {
      is: 2,
      then: (schema) =>
        schema
          .required("validations_select_warehouse")
          .test(
            "defaultAddressDeliveryTypeId",
            "validations_select_warehouse",
            (value: { id: number | string; mainText: string }) =>
              !!value && (!!value.id || value.id === 0) && !!value.mainText,
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    addressIdPreDelivery: Yup.object().when("defaultAddressDeliveryTypeId", {
      is: 1,
      then: (schema) =>
        schema
          .required("validations_select_delivery_address")
          .test(
            "defaultAddressDeliveryTypeId",
            "validations_select_delivery_address",
            (value: { id: number | string; mainText: string }) =>
              !!value && (!!value.id || value.id === 0) && !!value.mainText,
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    shop: Yup.mixed().required("validations_select_shop"),
  });

//@ts-ignore
export const parcelItemsSchemaGe: Yup.ObjectSchema<TParcelItemsGE> =
  Yup.object().shape({
    products: Yup.array()
      .of(
        Yup.object()
          .shape({
            productPriceUsd: Yup.string()
              .required("validations_product_price_required")
              .test(
                "is-greater-than-zero",
                "validation_greater_than_zero",
                (value: unknown) => {
                  if (typeof value !== "string" && typeof value !== "number")
                    return false;
                  const num = Number(value);
                  return num > 0;
                },
              ),
            productAmount: Yup.mixed()
              .test(
                "is-string-or-number",
                "validations_product_quantity_required",
                (value) =>
                  typeof value === "string" || typeof value === "number",
              )
              .test(
                "is-greater-than-zero",
                "validation_greater_than_zero",
                (value: unknown) => {
                  if (typeof value !== "string" && typeof value !== "number")
                    return false;
                  const num = Number(value);
                  return num > 0;
                },
              )
              .required("validations_product_quantity_required"),
            productCategoryId: Yup.object({
              id: Yup.number().required("validations_category_required"),
              mainText: Yup.string(),
            }).required("validations_category_required"),
            productDescription: Yup.string().max(
              255,
              "validations_value_shorter_than_255_characters",
            ),
          })
          .required("validations_product_details_required"), // Ensure the whole product object is required
      )
      .default([])
      .required("validations_products_required"),
    productPriceUsd: Yup.string()
      .required("validations_product_price_required")
      .test(
        "is-greater-than-zero",
        "validation_greater_than_zero",
        (value: unknown) => {
          if (typeof value !== "string" && typeof value !== "number")
            return false;
          const num = Number(value);
          return num > 0;
        },
      ),
    productAmount: Yup.mixed()
      .test(
        "is-string-or-number",
        "validations_product_quantity_required",
        (value) => typeof value === "string" || typeof value === "number",
      )
      .test(
        "is-greater-than-zero",
        "validation_greater_than_zero",
        (value: unknown) => {
          if (typeof value !== "string" && typeof value !== "number")
            return false;
          const num = Number(value);
          return num > 0;
        },
      )
      .required("validations_product_quantity_required"),
    productCategoryId: Yup.object({
      id: Yup.number().required("validations_category_required"),
      mainText: Yup.string(),
    }).required("validations_category_required"),
    productDescription: Yup.string().max(
      255,
      "validations_value_shorter_than_255_characters",
    ),
  });
